
<template>
  <div>
    <default-card>
      <template slot="title-left"> 
        Reserva do mês 💰
      </template>
      <template slot="title-right"></template>
      <template slot="content">
        <company-financial-settings reserve class="px-3"/>
      </template>
    </default-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'CompanyFinancialReserve',
  components: {
    CompanyFinancialSettings: ()=>import('./CompanyFinancialSettings/CompanyFinancialSettings.vue'),
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },

}
</script>

<style scoped>

</style>